import { CardSlider } from 'app/components/card-slider';
import { withErrorBoundary } from 'app/components/error-boundary';
import { OnboardingProgress } from 'app/components/progress';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { useScopedTranslation } from 'app/hooks/i18n';
import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle } from 'app/utils/web-helpers';
import React, { useEffect, useState } from 'react';
import { type LayoutChangeEvent } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button } from 'app/design/primitives/button';
import { LoginSheet, useLoginSheet } from '../onboarding/login';
import { usePresentPartageClubCarouselItems } from './present-partage-club-carousel-items';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const PresentPartageClubScreenComponent: NavigationScreen<'presentPartageClub'> = ({ navigation }) => {
  const { t } = useScopedTranslation();
  const setPageTitle = usePageTitle('presentPartageClub');
  useEffect(() => setPageTitle('headerTitle'), [setPageTitle]);
  const { showLoginSheet, loginSheetState } = useLoginSheet();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [footerHeight, setFooterHeight] = useState(160);

  const onFooterLayout = (e: LayoutChangeEvent) => {
    const h = e.nativeEvent.layout.height;
    if (h > 0) setFooterHeight(h);
  };

  const carouselItems = usePresentPartageClubCarouselItems();

  if (carouselItems.length === 0) {
    navigation.goBack();
    return null;
  }

  return (
    <>
      <CardSlider
        contentPaddingBottom={footerHeight}
        items={carouselItems}
        onItemChange={(_, index) => setCurrentIndex(index)}
        autoScrollDelay={6000}
        autoScrollToNext
        showArrows
        renderFooter={() => (
          <SafeAreaView
            onLayout={onFooterLayout}
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              paddingHorizontal: theme.spacing['spacing.general.x4'],
            }}
          >
            <Column gap="spacing.general.x2" width="100%" paddingBottom="spacing.general.x4">
              <OnboardingProgress totalSteps={3} currentStep={currentIndex} />

              <Button
                testID="signup-button"
                variant="primary"
                onPress={() => {
                  navigation.navigate('onboarding', { screen: 'contact-information' }, { pop: true });
                }}
                style={{
                  borderColor: 'white',
                  borderWidth: 2,
                  backgroundColor: 'white',
                  borderRadius: theme.borderRadii['radius.xl'],
                }}
              >
                <Text style={{ color: theme.colors['text.primary'], fontWeight: '700', fontSize: 14 }}>
                  {t(`button.noAccountYet`)}
                </Text>
              </Button>

              <Button
                testID="login-button"
                variant="primary"
                onPress={showLoginSheet}
                style={{
                  borderColor: 'white',
                  borderWidth: 2,
                  backgroundColor: 'transparent',
                  borderRadius: theme.borderRadii['radius.xl'],
                }}
              >
                <Text style={{ color: 'white', fontWeight: '700', fontSize: 14 }}>
                  {t(`button.alreadyHaveAnAccount`)}
                </Text>
              </Button>
            </Column>
          </SafeAreaView>
        )}
      />

      <LoginSheet state={loginSheetState} onLoginComplete={() => navigation.reset({ routes: [{ name: 'main' }] })} />
    </>
  );
};

export const PresentPartageClubScreen: NavigationScreen<'presentPartageClub'> = withErrorBoundary(
  PresentPartageClubScreenComponent,
);
